<template>
  <div class="mobile-chronology" v-if="isPrivate">
    <v-card
      class="d-flex align-center pa-2"
      color="#44485C"
      flat
      height="36"
      dark
      tile
    >
      <div class="caption font-weight-bold">
        クロノロジー 一覧 {{ appVersion }}
      </div>
      <v-spacer></v-spacer>
      <v-btn x-small @click="reload()" class="ml-2" light>
        更新
      </v-btn>
    </v-card>
    <div class="nav-area">
      <ChronologyList
        ref="chronologyList"
        :map="map"
        height="100%"
        class="mx-2"
        v-show="nav === 'list'"
      />
      <LMap
        ref="mobileChronologyMap"
        id="mobileChronologyMap"
        :zoom="11"
        :center="center"
        :options="{ zoomControl: false, scrollWheelZoom: true }"
        :zoom-animation="false"
        style="height: 100%"
        v-show="nav === 'map'"
      >
        <LTileLayer :url="tileLayerUrl" />
        <ChronologyLayer :map="map" />
      </LMap>
    </div>
    <v-bottom-navigation
      v-model="nav"
      grow
      height="50"
      background-color="#44485C"
      dark
    >
      <v-btn value="list">
        <span>リスト</span>
        <v-icon>mdi-list-box-outline</v-icon>
      </v-btn>
      <v-btn value="map">
        <span>地図</span>
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>
<script>
import { LMap, LTileLayer } from "vue2-leaflet";
import { BRANCH_OFFICE } from "../enums/BranchOffice";
import ChronologyList from "../components/chronology/ChronologyList";
import ChronologyLayer from "../components/chronology/ChronologyLayer";
export default {
  name: "MobileChronology",
  components: {
    LMap,
    LTileLayer,
    ChronologyList,
    ChronologyLayer
  },
  data() {
    return {
      center: [BRANCH_OFFICE[0].lat, BRANCH_OFFICE[0].lng],
      nav: "list",
      map: null,
      tileLayerUrl: "https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
    };
  },

  computed: {
    appVersion() {
      if (process.env.VUE_APP_CHRONOLOGY_ALIAS === "stage") {
        return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : "";
      } else {
        return "";
      }
    },
    isPrivate() {
      return process.env.VUE_APP_MODE === "private";
    }
  },

  watch: {
    nav(val) {
      if (val === "list") {
        this.$refs.chronologyList.refresh();
      } else if (val === "map") {
        this.$nextTick(() => {
          this.map.invalidateSize();
        });
      }
    }
  },

  async created() {
    //
  },

  beforeDestroy() {
    //
  },

  async mounted() {
    if (!this.map) {
      this.map = this.$refs.mobileChronologyMap.mapObject;
    }
  },

  methods: {
    async reload() {
      window.location.reload(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-chronology {
  background-color: #fff;
}
.nav-area {
  height: calc(100dvh - 86px);
}
</style>
